import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-gray-lightShow" }
const _hoisted_2 = { class: "p-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "py-4 text-left border-b-2 border-green-show" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-xl font-bold" }, "ユーザー情報")
], -1)
const _hoisted_4 = { class: "space-y-8 py-4" }
const _hoisted_5 = { class: "text-left" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "py-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-left text-sm font-bold" }, [
    /*#__PURE__*/_createTextVNode(" ニックネーム "),
    /*#__PURE__*/_createElementVNode("span", { class: "text-xs text-red-500 ml-2" }, " 必須 ")
  ])
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "py-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-left text-sm font-bold" }, "氏名")
], -1)
const _hoisted_8 = { class: "space-y-4" }
const _hoisted_9 = { class: "flex space-x-2" }
const _hoisted_10 = { class: "text-left" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "text-left text-xs mb-1" }, [
  /*#__PURE__*/_createTextVNode(" 姓(漢字) "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-xs text-red-500 ml-2" }, " 必須 ")
], -1)
const _hoisted_12 = { class: "text-left" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "text-left text-xs mb-1" }, [
  /*#__PURE__*/_createTextVNode(" 名(漢字) "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-xs text-red-500 ml-2" }, " 必須 ")
], -1)
const _hoisted_14 = { class: "flex space-x-2" }
const _hoisted_15 = { class: "text-left" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { class: "text-left text-xs mb-1" }, [
  /*#__PURE__*/_createTextVNode(" 姓(ひらがな) "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-xs text-red-500 ml-2" }, " 必須 ")
], -1)
const _hoisted_17 = { class: "text-left" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", { class: "text-left text-xs mb-1" }, [
  /*#__PURE__*/_createTextVNode(" 名(ひらがな) "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-xs text-red-500 ml-2" }, " 必須 ")
], -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "py-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-left text-sm font-bold" }, "連絡先")
], -1)
const _hoisted_20 = { class: "space-y-4" }
const _hoisted_21 = { className: "mt-1 text-left" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", { class: "text-left text-xs" }, "電話番号", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "py-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-left text-sm font-bold" }, [
    /*#__PURE__*/_createTextVNode(" 性別 "),
    /*#__PURE__*/_createElementVNode("span", { class: "text-xs text-red-500 ml-2" }, " 必須 ")
  ])
], -1)
const _hoisted_24 = { className: "mt-1 text-left" }
const _hoisted_25 = { class: "flex space-x-10" }
const _hoisted_26 = ["for"]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "py-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-left text-sm font-bold" }, "生年月日")
], -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "py-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-left text-sm font-bold" }, [
    /*#__PURE__*/_createTextVNode(" お住いの都道府県 "),
    /*#__PURE__*/_createElementVNode("span", { class: "text-xs text-red-500 ml-2" }, " 必須 ")
  ])
], -1)
const _hoisted_29 = { class: "text-left" }
const _hoisted_30 = ["value"]
const _hoisted_31 = { class: "mt-4 mb-8" }
const _hoisted_32 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_ChevronDownIcon = _resolveComponent("ChevronDownIcon")!
  const _component_Form = _resolveComponent("Form")!
  const _component_van_date_picker = _resolveComponent("van-date-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Form, { onSubmit: _ctx.onSubmit }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", null, [
                _createVNode(_component_Field, {
                  modelValue: _ctx.userProfile.nickName,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userProfile.nickName) = $event)),
                  name: "nickName",
                  type: "text",
                  class: "block w-full border-0 border-b border-green-lightShow bg-transparent focus:ring-transparent placeholder:text-gray-placeholder",
                  placeholder: "やまたろ",
                  rules: "required"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  class: "text-red-500 text-xs",
                  name: "nickName"
                })
              ])
            ]),
            _createElementVNode("div", null, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.userProfile.lastName,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.userProfile.lastName) = $event)),
                      name: "lastName",
                      type: "text",
                      class: "block w-full border-0 border-b border-green-lightShow bg-transparent focus:ring-transparent placeholder:text-gray-placeholder",
                      placeholder: "山田",
                      rules: "required"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      class: "text-red-500 text-xs",
                      name: "lastName"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _hoisted_13,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.userProfile.firstName,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.userProfile.firstName) = $event)),
                      name: "firstName",
                      type: "text",
                      class: "block w-full border-0 border-b border-green-lightShow bg-transparent focus:ring-transparent placeholder:text-gray-placeholder",
                      placeholder: "太郎",
                      rules: "required"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      class: "text-red-500 text-xs",
                      name: "firstName"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.userProfile.lastNameKana,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.userProfile.lastNameKana) = $event)),
                      name: "lastNameKana",
                      type: "text",
                      class: "block w-full border-0 border-b border-green-lightShow bg-transparent focus:ring-transparent placeholder:text-gray-placeholder",
                      placeholder: "やまだ",
                      rules: "required"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      class: "text-red-500 text-xs",
                      name: "lastNameKana"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _hoisted_18,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.userProfile.firstNameKana,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.userProfile.firstNameKana) = $event)),
                      name: "firstNameKana",
                      type: "text",
                      class: "block w-full border-0 border-b border-green-lightShow bg-transparent focus:ring-transparent placeholder:text-gray-placeholder",
                      placeholder: "たろう",
                      rules: "required"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      class: "text-red-500 text-xs",
                      name: "firstNameKana"
                    })
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", null, [
                _hoisted_19,
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _hoisted_22,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.userProfile.phoneNumber,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.userProfile.phoneNumber) = $event)),
                      name: "phoneNumber",
                      type: "number",
                      class: "block w-full border-0 border-b border-green-lightShow bg-transparent focus:ring-transparent placeholder:text-gray-placeholder",
                      placeholder: "08012345678"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      class: "text-red-500 text-xs",
                      name: "phoneNumber"
                    })
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", null, [
              _hoisted_23,
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.genderItems, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.id,
                      class: "flex items-center"
                    }, [
                      _createVNode(_component_Field, {
                        id: item.name,
                        modelValue: _ctx.userProfile.genderId,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.userProfile.genderId) = $event)),
                        name: "gender",
                        rules: "requiredNullable",
                        value: item.id,
                        type: "radio",
                        class: "h-4 w-4 border-gray-300 text-green-show focus:ring-transparent"
                      }, null, 8, ["id", "modelValue", "value"]),
                      _createElementVNode("label", {
                        for: item.name,
                        onclick: "",
                        class: "ml-3 block text-sm font-medium text-gray-700"
                      }, _toDisplayString(item.name), 9, _hoisted_26)
                    ]))
                  }), 128))
                ]),
                _createVNode(_component_ErrorMessage, {
                  class: "text-red-500 text-xs",
                  name: "gender"
                })
              ])
            ]),
            _createElementVNode("div", null, [
              _hoisted_27,
              _createElementVNode("div", {
                class: "flex border-b border-green-lightShow",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showDatePicker()))
              }, [
                _createVNode(_component_Field, { name: "birthDay" }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.userBirthDay) = $event)),
                      type: "text",
                      placeholder: "1998年1月1日",
                      class: "block w-full border-0 bg-transparent focus:ring-transparent",
                      readonly: ""
                    }, null, 512), [
                      [_vModelText, _ctx.userBirthDay]
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ChevronDownIcon, { class: "w-5 h-5 m-auto mr-4" })
              ])
            ]),
            _createElementVNode("div", null, [
              _hoisted_28,
              _createElementVNode("div", _hoisted_29, [
                _createVNode(_component_Field, {
                  modelValue: _ctx.userProfile.prefectureId,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.userProfile.prefectureId) = $event)),
                  name: "prefecture",
                  as: "select",
                  rules: "requiredNullable",
                  class: "mt-1 block w-full border-0 border-b border-green-lightShow bg-transparent focus:ring-transparent"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.prefectures, (prefecture) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: prefecture.prefectureId,
                        value: prefecture.prefectureId
                      }, _toDisplayString(prefecture.name), 9, _hoisted_30))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  class: "text-red-500 text-xs",
                  name: "prefecture"
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("button", {
              type: "submit",
              class: _normalizeClass(["text-center block w-full items-center rounded-md border border-transparent bg-green-show px-6 py-2 text-base font-medium text-white shadow-sm", _ctx.isLoading ? 'opacity-50' : '']),
              disabled: _ctx.isLoading
            }, " 登録する ", 10, _hoisted_32)
          ])
        ])
      ]),
      _: 1
    }, 8, ["onSubmit"]),
    _createVNode(_component_van_popup, {
      show: _ctx.isShowDatePicker,
      "onUpdate:show": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.isShowDatePicker) = $event)),
      position: "bottom",
      style: {height: '40%'}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_date_picker, {
          modelValue: _ctx.currentDate,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.currentDate) = $event)),
          title: "Choose Date",
          "confirm-button-text": "確定",
          "cancel-button-text": "取消",
          "min-date": _ctx.minDate,
          "max-date": _ctx.maxDate,
          onConfirm: _ctx.confirmDatePick,
          onCancel: _ctx.cancelDatePick
        }, null, 8, ["modelValue", "min-date", "max-date", "onConfirm", "onCancel"])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}